// import '@material-ui/lab/themeAugmentation'

import { createMuiTheme, Theme, ThemeOptions } from '@material-ui/core/styles'

import breakpoints from './breakpoints'
import {
  commonPalette,
  greenPalette,
  greyPalette,
  purplePalette,
  redPalette,
  tealPalette,
  yellowPalette,
  ColorsPalette,
} from './colors'

export interface CustomThemeOptions extends ThemeOptions {
  palette?: ThemeOptions['palette'] & ColorsPalette
}

export const commonTheme: CustomThemeOptions = {
  palette: {
    type: 'light',
    common: commonPalette,
    colors: {
      yellow: yellowPalette,
      red: redPalette,
      green: greenPalette,
      purple: purplePalette,
      teal: tealPalette,
      // redundant, just out of consistency
      grey: greyPalette,
    },
    primary: {
      main: yellowPalette[300],
      dark: yellowPalette[500],
    },
    secondary: {
      main: purplePalette[500],
      dark: purplePalette[400],
    },
    error: {
      main: redPalette[500],
      dark: redPalette[400],
    },
    grey: greyPalette,
  },
  breakpoints,
}

export interface CustomTheme extends Theme {
  palette: Theme['palette'] & ColorsPalette
}
const theme: CustomTheme = createMuiTheme(commonTheme)

export default theme
